const state = {
  Manager: null,
  User: null,
  Taxpayer: null,
};

const getters = {
  Manager: (state) => state.Manager,
  User: (state) => state.User,
  Taxpayer: (state) => state.Taxpayer,
  isManagerLoggedIn: () => state.Manager != null,
  isUserLoggedIn: () => state.User != null,
  isTaxpayerLoggedIn: () => state.Taxpayer != null,
};

const mutations = {
  setManager(state, data) {
    state.Manager = data;
  },

  setUser(state, data) {
    state.User = data;
  },

  setTaxpayer(state, data) {
    state.Taxpayer = data;
  },
};

const actions = {
  setManager({ commit }, manager) {
    commit('setManager', manager);
  },

  setUser({ commit }, user) {
    commit('setUser', user);
  },

  setTaxpayer({ commit }, taxpayer) {
    commit('setTaxpayer', taxpayer);
  },

  async registerUser(ctx, user_details) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let {
        data: {
          success,
          message,
          data: { user },
        },
      } = await axios.post('/user/register', user_details);

      return { success, message, user };
    } catch (error) {
      throw error.response.data;
    }
  },

  async loginUser(ctx, credentials) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let options = {
        headers: { Accept: 'application/json' },
      };

      let {
        data: {
          message,
          success,
          data: { user },
        },
      } = await axios.post('/user/login', credentials, options);

      return { success, message, user };
    } catch (error) {
      throw error.response.data;
    }
  },

  async sendPasswordResetLinkUser(ctx, credentials) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let {
        data: { message, success },
      } = await axios.post('/user/password/email', credentials);

      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },

  async resetPasswordUser(ctx, data) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let {
        data: { message, success },
      } = await axios.post('/user/password/reset', data);

      return { message, success };
    } catch (error) {
      throw error.response.data;
    }
  },

  async loginManager(ctx, credentials) {
    try {
      let options = {
        headers: { Accept: 'application/json' },
      };

      await axios.get('/sanctum/csrf-cookie');

      let {
        data: {
          message,
          success,
          data: { manager },
        },
      } = await axios.post('/manager/login', credentials, options);

      return { success, message, manager };
    } catch (error) {
      throw error.response.data;
    }
  },

  async sendPasswordResetLinkManager(ctx, credentials) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let {
        data: { message, success },
      } = await axios.post('/manager/password/email', credentials);

      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },

  async resetPasswordManager(ctx, data) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let {
        data: { message, success },
      } = await axios.post('/manager/password/reset', data);

      return { message, success };
    } catch (error) {
      throw error.response.data;
    }
  },

  async registerTaxpayer(ctx, taxpayer_details) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let {
        data: {
          success,
          message,
          data: { taxpayer },
        },
      } = await axios.post('/taxpayer/register', taxpayer_details);

      return { success, message, taxpayer };
    } catch (error) {
      throw error.response.data;
    }
  },

  async loginTaxpayer(ctx, credentials) {
    try {
      await axios.get('/sanctum/csrf-cookie');
      let options = {
        headers: { Accept: 'application/json' },
      };

      let {
        data: {
          message,
          success,
          data: { taxpayer },
        },
      } = await axios.post('/taxpayer/login', credentials, options);

      return { success, message, taxpayer };
    } catch (error) {
      throw error.response.data;
    }
  },

  async sendPasswordResetLinkTaxpayer(ctx, credentials) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let {
        data: { message, success },
      } = await axios.post('/taxpayer/password/email', credentials);

      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },

  async resetPasswordTaxpayer(ctx, data) {
    try {
      await axios.get('/sanctum/csrf-cookie');

      let {
        data: { message, success },
      } = await axios.post('/taxpayer/password/reset', data);

      return { message, success };
    } catch (error) {
      throw error.response.data;
    }
  },
};

const namespaced = true;

export default { state, getters, mutations, actions, namespaced };
